
import React from 'react';
import { DiagnosticResult } from './types';

interface AuthStatusSectionProps {
  results: DiagnosticResult;
}

export const AuthStatusSection: React.FC<AuthStatusSectionProps> = ({ results }) => {
  return (
    <div className="bg-muted p-4 rounded-md">
      <h3 className="font-medium mb-2">Authentication Status</h3>
      <div className="text-sm space-y-1">
        <p>User ID: <code className="bg-background px-1 rounded">{results.auth_status.uid || 'NULL'}</code></p>
        <p>Email: <code className="bg-background px-1 rounded">{results.auth_status.email || 'NULL'}</code></p>
        <p>Is Authenticated: <span className={results.auth_status.is_authenticated ? "text-green-500" : "text-red-500"}>
          {results.auth_status.is_authenticated ? "Yes" : "No"}
        </span></p>
      </div>
    </div>
  );
};
